module.exports = __webpack_public_path__ + "static/works-belamy-9787386982bae7ffb1661c5f71fadc86.png";